import PageContato from '../../Components/Page-Contato/PageContato';
import Footer from '../../Components/Footer/Footer';
import Agendamento from '../../Components/Banner-Agendamentos/BanAgendamentos';

function Contato() {
    return (
        <>
            <div id="PageContato">
                <PageContato />
            </div>
            <div id="Agendamento">
                <Agendamento/>
            </div>
            <div id="Footer">
                <Footer/>
            </div>
        </>
    );
}

export default Contato;